export enum ProductType {
  Sales = 1,
  Purchase = 2,
  Asset = 3,
}
